import templateUrl from './app-nav-footer-contact.html';
import find from 'lodash/find';
import size from 'lodash/size';

export const navFooterContactComponent = {
	templateUrl,

	bindings: {
		features: '<'
	},

	controller: class NavFooterContactComponent {
		$onInit() {
			this.getThereProgramCallCenter;
		}

		$onChanges(changes) {
			if(changes && changes.features && size(changes.features.currentValue) > 0){
				const menus = changes.features.currentValue;
				const getThereProgramMenuSubMenus = find(menus,['name','GettherePrograms']).subfeature;
				this.getThereProgramCallCenter = find(getThereProgramMenuSubMenus, ['name', 'CallCenter'])
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/app-nav/app-nav-footer-contact.component.js